import { Interface } from "ethers";
import { flattenCondition } from "../../condition/flattenCondition";
import { Roles__factory } from "../../../typechain";
const rolesInterface = Roles__factory.createInterface();
const posterInterface = Interface.from([
    "function post(string content,string tag)",
]);
export const encodeCalls = (calls, rolesMod) => {
    return calls.map((call) => {
        switch (call.call) {
            case "allowTarget": {
                return {
                    to: rolesMod,
                    data: rolesInterface.encodeFunctionData("allowTarget", [
                        call.roleKey,
                        call.targetAddress,
                        call.executionOptions,
                    ]),
                };
            }
            case "scopeTarget": {
                return {
                    to: rolesMod,
                    data: rolesInterface.encodeFunctionData("scopeTarget", [
                        call.roleKey,
                        call.targetAddress,
                    ]),
                };
            }
            case "revokeTarget": {
                return {
                    to: rolesMod,
                    data: rolesInterface.encodeFunctionData("revokeTarget", [
                        call.roleKey,
                        call.targetAddress,
                    ]),
                };
            }
            case "allowFunction": {
                return {
                    to: rolesMod,
                    data: rolesInterface.encodeFunctionData("allowFunction", [
                        call.roleKey,
                        call.targetAddress,
                        call.selector,
                        call.executionOptions,
                    ]),
                };
            }
            case "scopeFunction": {
                return {
                    to: rolesMod,
                    data: rolesInterface.encodeFunctionData("scopeFunction", [
                        call.roleKey,
                        call.targetAddress,
                        call.selector,
                        flattenCondition(call.condition).map((c) => ({
                            ...c,
                            compValue: c.compValue || "0x",
                        })),
                        call.executionOptions,
                    ]),
                };
            }
            case "revokeFunction": {
                return {
                    to: rolesMod,
                    data: rolesInterface.encodeFunctionData("revokeFunction", [
                        call.roleKey,
                        call.targetAddress,
                        call.selector,
                    ]),
                };
            }
            case "assignRoles": {
                return {
                    to: rolesMod,
                    data: rolesInterface.encodeFunctionData("assignRoles", [
                        call.member,
                        [call.roleKey],
                        [call.join],
                    ]),
                };
            }
            case "setAllowance": {
                return {
                    to: rolesMod,
                    data: rolesInterface.encodeFunctionData("setAllowance", [
                        call.key,
                        call.balance,
                        call.maxRefill,
                        call.refill,
                        call.period,
                        call.timestamp,
                    ]),
                };
            }
            case "postAnnotations": {
                const content = JSON.stringify({
                    rolesMod,
                    roleKey: call.roleKey,
                    ...call.body,
                });
                const tag = POSTER_TAG_ROLES_ANNOTATION;
                return {
                    to: POSTER_ADDRESS,
                    data: posterInterface.encodeFunctionData("post", [
                        content,
                        tag,
                    ]),
                };
            }
        }
    });
};
// EIP-3722 Poster contract
const POSTER_ADDRESS = "0x000000000000cd17345801aa8147b8D3950260FF";
const POSTER_TAG_ROLES_ANNOTATION = "ROLES_PERMISSION_ANNOTATION";
